import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAdmin, adminAxios } from "./AdminContext";
import { MessageSquareQuote, BookMarked, Mail, ShieldCheck } from "lucide-react";

export default function AdminDashboard() {
  const { token } = useAdmin();
  const [stats, setStats] = useState({ pending: 0, approved: 0, references: 0, messages: 0 });

  useEffect(() => {
    const ax = adminAxios(token);
    Promise.all([
      ax.get("/admin/testimonials?status=pending").catch(() => ({ data: { items: [] } })),
      ax.get("/admin/testimonials?status=approved").catch(() => ({ data: { items: [] } })),
      ax.get("/admin/references").catch(() => ({ data: { items: [] } })),
      ax.get("/admin/messages").catch(() => ({ data: { items: [] } })),
    ]).then(([p, a, r, m]) => setStats({
      pending: p.data.items.length, approved: a.data.items.length,
      references: r.data.items.length, messages: m.data.items.length,
    }));
  }, [token]);

  const cards = [
    { label: "Bekleyen Yorumlar", value: stats.pending, icon: MessageSquareQuote, to: "/admin/yorumlar", accent: "text-[#FF3B30]" },
    { label: "Onaylanmış Yorumlar", value: stats.approved, icon: ShieldCheck, to: "/admin/yorumlar", accent: "text-[#34C759]" },
    { label: "Referanslar", value: stats.references, icon: BookMarked, to: "/admin/referanslar", accent: "text-[#007AFF]" },
    { label: "İletişim Mesajları", value: stats.messages, icon: Mail, to: "/admin/mesajlar", accent: "text-white/80" },
  ];

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Genel Bakış</h1>
        <p className="text-white/50 mt-2">Site yönetimi için merkezi panel.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map(({ label, value, icon: Icon, to, accent }) => (
          <Link key={label} to={to} className="rounded-2xl bg-white/[0.03] border border-white/10 p-6 hover:border-[#FF3B30]/40 transition group">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-white/50">{label}</div>
                <div className={`mt-3 font-display text-4xl font-bold ${accent}`}>{value}</div>
              </div>
              <Icon size={22} className={`${accent} opacity-70 group-hover:opacity-100`} />
            </div>
          </Link>
        ))}
      </div>

      <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-6">
        <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#FF3B30] mb-2">Hızlı Erişim</div>
        <ul className="space-y-2 text-sm text-white/70">
          <li>• Yeni yorumlar geldiğinde "Bekleyen Yorumlar" sayısı buradan görünür ve e-posta bildirimi gönderilir.</li>
          <li>• Referans logolarını ekleyip listeyi yönetmek için "Referanslar" bölümüne girin.</li>
          <li>• Cloudflare Turnstile anahtarlarını ve admin e-postanızı "Site Ayarları"ndan güncelleyin.</li>
          <li>• Şifrenizi "Hesap Ayarları"ndan değiştirebilirsiniz; değişiklik sonrası otomatik çıkış yapılır.</li>
        </ul>
      </div>
    </div>
  );
}
